import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { authService } from '../services/auth.service';
import { PUBLIC_PATHS } from '../constants/routes.constants';

const UserValidation = () => {
  const location = useLocation();
  const { isAuthenticated } = useAuth();

  useEffect(() => {
    if (!isAuthenticated || PUBLIC_PATHS.includes(location.pathname)) return;

    // No skipAuthRedirect — the http-client interceptor will attempt a token
    // refresh on 401. If refresh succeeds the profile call is retried silently.
    // If refresh fails, onTokenExpiry fires (which calls the full logout handler).
    authService.getProfile().catch(() => {
      // Refresh failed — onTokenExpiry already triggered logout/redirect.
    });
  }, [location.pathname, isAuthenticated]);

  return null;
};

export default UserValidation;
